var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-alert",
    {
      class: _vm.ContainerClass,
      attrs: {
        border: "left",
        color: "primary",
        "rounded-lg": "",
        "colored-border": "",
        height: "40",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "append",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "text-right d-flex align-center px-1" },
                  [
                    !_vm.$store.state.isLoading
                      ? _c(
                          "v-chip",
                          {
                            staticClass: "mx-2",
                            style: {
                              borderLeft: "8px solid " + _vm.slideColor,
                            },
                            attrs: { small: "", label: "", color: _vm.bgColor },
                          },
                          [_vm._t("status")],
                          2
                        )
                      : _vm._e(),
                    _vm.triger
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              color: "primary",
                              small: "",
                              disabled: _vm.$store.state.isLoading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("triger")
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "material-icons-round" },
                              [_vm._v(_vm._s(_vm.trigerIcon))]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _c(
        "v-sheet",
        {
          staticClass:
            "\n      align-center\n      d-flex\n      align-self-center\n      fill-height\n      pl-4\n      rounded-lg\n      text--secondary text-caption\n      justify-space-between\n    ",
          attrs: { height: "40" },
        },
        [_vm._t("time")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }